module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_twitter-720e30ef2839748aeec7cb6e007c1768.svg";